const index = () => import(/* webpackChunkName: "herb" */ './Index');

//2019年省级工业转型升级专项资金
export default {
  routes: [
    {
      path: '/herb/v2020/index',
      name: 'cherb_v2020_index',
      component: index,
      meta:{public:true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/special/herb/v2020/router.js